var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c(_vm.icon,{tag:"component",staticClass:"icon",attrs:{"size":"xs","color":_vm.iconColor,"active":_vm.active}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }